





























import CommonBase from "./CommonBase";
import {DateTime} from "../modules/models";
import {Component, Prop} from "vue-property-decorator";

@Component
export default class DatePicker extends CommonBase {
    @Prop()
    value!: DateTime;
    @Prop({default: false})
    solo!: boolean;
    @Prop({default: false})
    flat!: boolean;
    @Prop({default: true})
    singleLine!: boolean;
    @Prop({default: false})
    outline!: boolean;

  @Prop()
    label!: string;

    get isoValue(): string | null {
        return this.value != null ? this.value.toISOWithOffset() : null;
    }
    set isoValue(isoStr: string | null) {
        if(isoStr != null) {
            const newVal = DateTime.fromString(isoStr).toMidnight();
            if (this.value == null || newVal.millis() != this.value.millis()) {
                this.$emit("input", newVal);
            }
        } else if(isoStr == null && this.value != null) {
            this.$emit("input", isoStr);
        }
    }
    get norValue(): string | null {
        return this.value != null ? this.value.toLocalDate() : null;
    }
    set norValue(norStr: string | null) {
        try {
            if(norStr != null) {
                // with input mask, the value is a continous string of digits
                const newVal = DateTime.fromNorwStyleNoDots(norStr);
                if (this.value == null || newVal.millis() != this.value.millis()) {
                    this.$emit("input", newVal);
                }
            } else if(norStr == null && this.value != null) {
                this.$emit("input", norStr);
            }
        } catch (error) {
            // Do nothing, will keep the old value
        }
    }

}
